<template>
  <div class="device-stats">
    <div class="flex flex-wrap bg-white w-full h-full px-2 py-2">
      {{ $t('message.devicestats.infodispositivo') }}

      <div class="block w-full md:w-5/6 h-full mt-1">
        <span class="text-sm font-medium"> {{ currentDevice.name }} </span>
        <p class="text-xs">{{ lastassign.lote }} - {{ lastassign.product }}</p>
      </div>

      <div
        class="w-full md:w-1/6 h-full mt-1 pr-1 flex justify-end text-gray-600"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-settings"
        >
          <circle cx="12" cy="12" r="3"></circle>
          <path
            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
          ></path>
        </svg>
      </div>

      <div class="w-full h-full border border-gray-300 my-1">
        <table class="min-w-full divide-y divide-gray-200">
          <tbody class="bg-gray-50 divide-y divide-gray-200">
            <tr class="hover:bg-gray-200">
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ $t('message.devicestats.prodacum') }}:
              </td>
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ acumCounts }} {{ currentDevice.unit }}
              </td>
            </tr>
            <tr class="hover:bg-gray-200">
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ $t('message.devicestats.desde') }}:
              </td>
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ startFormat }}
              </td>
            </tr>
            <tr class="hover:bg-gray-200">
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ $t('message.devicestats.hasta') }}:
              </td>
              <td class="px-4 py-2 text-xs text-gray-700">
                {{ endFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-full h-full">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="button"
            v-on:click="$emit('change-product')"
            class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
          >
            {{ $t('message.devicestats.cambiarproducto') }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format, addSeconds, intervalToDuration, getUnixTime } from 'date-fns';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'device-stats',
  props: {
    devid: Number,
    modal: Boolean
  },
  data() {
    return {
      lastassign: {}
    };
  },
  mounted() {
    this.waitForData();
  },
  computed: {
    ...mapGetters([
      'innerStart',
      'innerEnd',
      'acumCounts',
      'acumDetentions',
      'currentDevice'
    ]),
    start() {
      return getUnixTime(this.innerStart);
    },
    end() {
      return getUnixTime(this.innerEnd);
    },
    startFormat() {
      return format(this.innerStart, 'dd/MM/yyyy - HH:mm:ss');
    },
    endFormat() {
      return format(this.innerEnd, 'dd/MM/yyyy - HH:mm:ss');
    },
    acumWorking() {
      return this.end - this.start - this.acumDetentions;
    }
  },
  methods: {
    ...mapActions(['getAcumCounts', 'getAcumDetentions']),
    async waitForData() {
      await this.getAcumCounts({
        devid: this.devid,
        freq: 'minute',
        start: this.start,
        end: this.end
      });
      await this.getAcumDetentions({
        devid: this.devid,
        start: this.start,
        end: this.end
      });
      const response = await this.$http.get(
        `assigns?devid=${this.devid}&start=${this.end}&end=${this.end}`
      );
      this.lastassign = response.data.assigns[0];
      console.log(JSON.parse(JSON.stringify(response)));
    },
    getPercent(secs) {
      const percent = (secs * 100) / (this.end - this.start);
      return Math.floor(percent * 100) / 100;
    },
    hhmmssFormat(secs) {
      let duration = { days: 0, hours: 0, minutes: 0, seconds: 0 };
      if (secs) {
        duration = intervalToDuration({
          start: new Date(),
          end: addSeconds(new Date(), secs)
        });
      }
      const zeros = data => (data <= 9 ? `0${data}` : data);

      if (duration.days == 1) {
        return `${duration.days} día, ${zeros(duration.hours)}:${zeros(
          duration.minutes
        )}:${zeros(duration.seconds)}`;
      } else if (duration.days > 1) {
        return `${duration.days} días, ${zeros(duration.hours)}:${zeros(
          duration.minutes
        )}:${zeros(duration.seconds)}`;
      } else {
        return `${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(
          duration.seconds
        )}`;
      }
    }
  },
  watch: {
    devid() {
      this.waitForData();
    },
    start() {
      this.waitForData();
    },
    end() {
      this.waitForData();
    },
    modal() {
      this.waitForData();
    }
  }
};
</script>

<style scoped>
/*.device-stats {
  }*/
</style>
